
			VANTA.WAVES({
				el: "body",
				mouseControls: true,
 				touchControls: true,
  				gyroControls: false,
  				minHeight: 200.00,
  				minWidth: 200.00,
  				scale: 1.00,
  				scaleMobile: 1.00,
  				color: 0x0
			});
		